export default {
  name: 'ReviewsPagination',
  props: {
    id: {
      type: String,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    }
  },
  emits: ['change'],
  data() {
    return {};
  },
  components: {},
  computed: {
    isHasPrevPage() {
      return this.currentPage > 1;
    },
    visiblePages() {
      const pages = [];
      const total = this.totalPages;
      const current = this.currentPage;

      if (total < 8) {
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
      } else {
        for (let i = 1; i <= Math.min(3, total); i++) {
          pages.push(i);
        }

        if (current > 4) {
          pages.push('...');
        }

        const start = Math.max(4, current - 1);
        const end = Math.min(total - 3, current + 1);
        for (let i = start; i <= end; i++) {
          pages.push(i);
        }

        if (end < total - 3) {
          pages.push('... ');
        }

        for (let i = Math.max(total - 2, end + 1); i <= total; i++) {
          pages.push(i);
        }
      }

      return pages;
    },
    isHasNextPage() {
      return this.currentPage < this.totalPages;
    }
  },
  mounted() {},
  methods: {
    onChangePage(page) {
      this.$emit('change', page);
    }
  }
};
